/**
 * Helpers tarifs atelier — pur, sans React ni I/O.
 *
 * Refonte tarifs 2026-05-15 : `tripleKey` retiré avec la matrice
 * `print_prices` (auto-calc POD la rend obsolète, voir migration 012).
 * Reste utile : `centsToEuros` / `eurosToCents` consommés par PricingTab
 * pour le champ `digital_default_price_cents`.
 */

/**
 * Cents (int) → euros (number, 2 décimales max).
 *
 * Utilise `Math.round` sur les cents pour normaliser un nombre
 * éventuellement non-entier provenant du JSON.
 */
export function centsToEuros(cents: number): number {
  return Math.round(cents) / 100
}

/**
 * Euros (number ou string) → cents (int).
 *
 * Retourne `null` si :
 *  - valeur vide / nulle / undefined (utilisateur n'a pas saisi)
 *  - non-fini (NaN, Infinity)
 *  - négatif (refusé côté Pydantic au PATCH ; on filtre en amont pour
 *    ne pas envoyer un payload qui sera rejeté en 422)
 *
 * Sinon retourne `Math.round(value * 100)` — robuste aux float
 * imprécisions (45.50 + 0.01 = 45.510000000000005 → 4551, pas 4550).
 */
export function eurosToCents(value: unknown): number | null {
  if (value === '' || value === null || value === undefined) return null
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n) || n < 0) return null
  return Math.round(n * 100)
}
